import React, { useState } from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import Input from "@infotech/uikit-input"
import { BackIcon } from "@infotech/uikit-icons"
import { FlatButton, PrimaryButton } from "@infotech/uikit-button"
import get from "lodash/get"
import { readAllStatuses } from "src/engine/modules/status/actions/creators"
import flow from "lodash/flow"
import ColorPicker from "./ColorPicker"
import { createNewStatus } from "./helper"
import styles from "./styles.css"

const getTestAttribute = name => `status-model-create-new-status-${name}`

const CreateStatus = ({
  showCreateStatus,
  triggerCreateStatus,
  toggleForm,
  readAllStatuses,
}) => {
  const [formValue, setFormValue] = useState({
    code: null,
    name: null,
    color: `#44bcf5`,
  })
  const [errors, setErrors] = useState({ code: null, name: null, color: null })
  const close = () => {
    toggleForm({
      show: true,
      id: showCreateStatus === `new` ? null : showCreateStatus,
    })
    triggerCreateStatus(false)
  }

  return (
    <Box loose className={styles.ModalWrapper}>
      <Box loose className={styles.ModalHeader} p="2md" flex row>
        <Box loose className={styles.CloseIcon} onClick={close}>
          <BackIcon color="#627d98" />
        </Box>
        <Box loose pl="2md">
          Создание статуса
        </Box>
      </Box>
      <Box loose className={styles.ModalBody} flex column>
        <Box loose pt="3md" pl="2md" w="320px">
          <FieldSet caption="Код" required>
            <div data-testid={getTestAttribute(`code`)}>
              <Input
                placeholder="Введите код"
                value={formValue.code}
                onChange={({ target: { value } }) => {
                  setFormValue({ ...formValue, code: value || null })
                }}
                error={get(errors, `code[0]`, null)}
              />
            </div>
          </FieldSet>
        </Box>
        <Box
          loose
          pt={get(errors, `code[0]`, null) ? `2md` : `3md`}
          flex
          row
          pl="2md"
        >
          <Box loose w="328px">
            <FieldSet caption="Название" required>
              <div data-testid={getTestAttribute(`name`)}>
                <Input
                  placeholder="Введите название"
                  value={formValue.name}
                  onChange={({ target: { value } }) => {
                    setFormValue({ ...formValue, name: value || null })
                  }}
                  error={get(errors, `name[0]`, null)}
                />
              </div>
            </FieldSet>
          </Box>
          <Box loose pl="2md" pt="4md">
            <ColorPicker
              name="color"
              value={formValue.color}
              setFormValue={setFormValue}
              formValue={formValue}
            />
          </Box>
        </Box>
      </Box>
      <Box loose flex row className={styles.ModalFooter} pt="12px" pb="12px">
        <Box loose pl="2md">
          <PrimaryButton
            type="submit"
            onClick={() => {
              createNewStatus({ formValue, close, setErrors, readAllStatuses })
            }}
          >
            Создать
          </PrimaryButton>
        </Box>
        <Box loose pl="2md">
          <FlatButton onClick={close}>Отмена</FlatButton>
        </Box>
        <Box loose />
      </Box>
    </Box>
  )
}

export default connect(null, dispatch => ({
  readAllStatuses: flow(readAllStatuses, dispatch),
}))(CreateStatus)
